import React from "react";
import styled from "styled-components";
const Progress = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  gap: 8px;
  width: 100%;
  position: relative;
`;

const Loader = styled.div<{ width?: string; color?: string }>`
  width: ${(props) => props.width || "100%"};
  height: 4px;
  background-color: ${(props) => (props.color ? props.color : "#20564b")};
  border-radius: 2px;
  margin-left: ${(props) => !props.width && "0px"};
  z-index: 10;
`;
const Count = styled.span`
  margin-right: 16px;
`;
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  type: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
  type,
}) => {
  const widthPercentage = totalSteps > 0 ? (currentStep / totalSteps) * 100 : 0;

  return (
    <Progress>
      <Loader color="#DEDEDE">
        <Loader
          width={`${widthPercentage}%`}
          color={type === "light" ? "white" : "#20564b"}
        />
      </Loader>
      {/* <Count>
        {currentStep}/{totalSteps}
      </Count> */}
    </Progress>
  );
};

export default ProgressBar;
